import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import ThemeContext from '../../utils/theming';

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: #fafafa;
    padding: 20px;
`;

const Body = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
`;

const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: center;
`;

const Description = styled.div`
    object-fit: contain;
    font-family: Lato;
    text-align: left;
`;

const ThankYouText = styled.span`
    color: #333;
    font-size: 14px;
    line-height: 1.3;
    font-weight: 300;
    display: inline-block;

    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: none;
    }
`;

const ConfirmationCard = props => {
    const theme = useContext(ThemeContext);
    return (
        <Container>
            <Body>
                <Content>
                    <ContentContainer>
                        {props.titleComponent}
                        <Description className="ie-object-fit-contain-polyfill">
                            {props.bodyComponent ? (
                                <ThankYouText theme={theme}>
                                    {props.bodyComponent}
                                </ThankYouText>
                            ) : (
                                <ThankYouText
                                    theme={theme}
                                    dangerouslySetInnerHTML={{
                                        __html: props.thankYouText
                                    }}
                                />
                            )}
                        </Description>
                        {props.buttonComponent && props.buttonComponent}
                        {props.fullAddress && props.getDirectionsComponent}
                    </ContentContainer>
                </Content>
            </Body>
        </Container>
    );
};

ConfirmationCard.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    titleComponent: PropTypes.element.isRequired,
    bodyComponent: PropTypes.element,
    buttonComponent: PropTypes.element,
    getDirectionsComponent: PropTypes.element,
    fullAddress: PropTypes.string
};

export default ConfirmationCard;
